
const apiConfig = {
                          baseURL: "https://api.b2win.site",
                         // baseURL: "http://localhost:5019",
                  };

export default apiConfig;